var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6723 0.77972C16.9993 0.437338 16.1761 0.705611 15.8338 1.37889L5.66443 21.3805C5.32214 22.0537 5.59041 22.8767 6.2636 23.219C6.46213 23.32 6.67371 23.3678 6.88218 23.3678C7.38044 23.3678 7.86074 23.0945 8.10212 22.6199L18.2715 2.61825C18.6138 1.94506 18.3455 1.12201 17.6723 0.77972Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3715 7.36555C10.3715 4.50608 8.04515 2.17969 5.18568 2.17969C2.32639 2.17969 0 4.50608 0 7.36555C0 10.2249 2.32639 12.5513 5.18577 12.5513C8.04524 12.5513 10.3715 10.2249 10.3715 7.36555ZM5.18577 9.81664C3.83429 9.81664 2.73468 8.71703 2.73468 7.36555C2.73468 6.01398 3.83429 4.91437 5.18577 4.91437C6.53734 4.91437 7.63696 6.01389 7.63696 7.36555C7.63686 8.71703 6.53734 9.81664 5.18577 9.81664Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8148 11.4473C15.9553 11.4473 13.6289 13.7737 13.6289 16.633C13.6289 19.4924 15.9552 21.8188 18.8148 21.8188C21.6741 21.8188 24.0005 19.4925 24.0005 16.633C24.0005 13.7736 21.6742 11.4473 18.8148 11.4473ZM18.8148 19.084C17.4632 19.084 16.3636 17.9844 16.3636 16.6329C16.3636 15.2815 17.4632 14.1819 18.8148 14.1819C20.1662 14.1819 21.2659 15.2815 21.2659 16.6329C21.2659 17.9844 20.1663 19.084 18.8148 19.084Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/percentage.14e360fd21f4ef4bb864f6a90bd7ba85.svg";
export { ForwardRef as ReactComponent };